import { render, staticRenderFns } from "./ViajeForm.vue?vue&type=template&id=590e75d6"
import script from "./ViajeForm.vue?vue&type=script&lang=js"
export * from "./ViajeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports